// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__13HeJ","img":"style_img__3NzGi","processing":"style_processing__2EtSb","cancel":"style_cancel__1fkmv"};